export const KAMBI_ROOT_ROUTE = 'tabtouch-sports'
export const KAMBI_HOME_HASH_ROUTE = `/${KAMBI_ROOT_ROUTE}/home` as const

export const KAMBI_BET_HISTORY_HASH_ROUTE = `/${KAMBI_ROOT_ROUTE}/bethistory` as const
export const KAMBI_PENDING_HASH_ROUTE = `${KAMBI_BET_HISTORY_HASH_ROUTE}/open` as const
export const KAMBI_RESULTED_HASH_ROUTE = `${KAMBI_BET_HISTORY_HASH_ROUTE}/settled` as const

export const KAMBI_CSS_HIDDEN_CLASS = 'mobi__kambi-hide-element'
export const KAMBI_BETSLIP_DIV_CLASS = 'mobi__kambi-betslip-unpinned'
export const KAMBI_CLIENT_DIV_ID = 'KambiBC'

export const KAMBI_BETSLIP_WRAPPER_DIV_ID = 'mobi__kambi-betslip-wrapper'

export const KAMBI_CONTAINER_BG_COLOR = '#f2f1f3'
